import { FuseAnimate } from "@fuse";
import _ from '@lodash';
import { AppBar, DialogActions, DialogContent, MenuItem, TextField, Toolbar, Typography, withStyles } from "@material-ui/core";
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import XAPPDialog from 'app/Core/Components/Dialog/XAPPDialog';
import ImprimirApp from "app/Core/Components/Imprimir/ImprimirApp";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as Helpers from "app/Core/Helpers";
import * as AppActions from 'app/store/actions';
import withReducer from 'app/store/withReducer';
import classNames from "classnames";
import MobileDetect from "mobile-detect";
import React from "react";
import { MdWarning } from "react-icons/md";
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import ReactTable from "react-table";
import withFixedColumns from "react-table-hoc-fixed-columns";
import { bindActionCreators } from 'redux';
import "styles/rthfc.css";
import * as Actions from './Store/Actions/TabelaHorasActions';
import reducer from './Store/Reducers/TabelaHorasReducer';

const ReactTableFixedColumns = withFixedColumns(ReactTable);
const md = new MobileDetect(window.navigator.userAgent);

const styles = (theme) => ({
    root: {
        color: theme.palette.text.primary,
        "& .rt-th": {
            backgroundColor: theme.palette.type === "dark" ? "#424242" : "#E6E6E6"
        },
        "& .rt-td": {
            backgroundColor: theme.palette.type === "dark" ? "#424242" : "#E6E6E6"
        }
    },
});

class Tabela {
    constructor(_AProps) {
        const ASemana = ["Domingo", "Segunda-Feira", "Terça-Feira", "Quarta-Feira", "Quinta-Feira", "Sexta-Feira", "Sábado"];
        var AInicio = new Date(_AProps.inicio + " 00:00:01");
        var AFim = new Date(_AProps.fim + " 00:00:01");
        var ARow = 0;
        while (AInicio <= AFim) {
            this[ARow] = {
                dia: AInicio.getDate(),
                diasemana: AInicio.getDate() + " " + ASemana[AInicio.getUTCDay()].substring(0, 3),
                entrada1: "",
                saida1: "",
                total1: 0,
                entrada2: "",
                saida2: "",
                total2: 0,
                natureza: "",
                observacao: "",
                diferenca: 0,
                diferencadescricao: ""
            };
            AInicio = Helpers.addDays(AInicio, 1);
            ARow++;
        }
    }
}

class TabelaHoras extends XAPPComponent {

    state = {
        inicio: null,
        fim: null,
        confirmacao: false
    }

    componentDidMount() {
        const { user, formulario, TabelaHoras, getJornada, xappRouteParams } = this.props;
        if (!_.isUndefined(user) && (_.isUndefined(TabelaHoras.jornada) || _.isNull(TabelaHoras.jornada))) {
            getJornada(user.usuario, xappRouteParams);
        }

        if (!_.isNull(formulario) && !_.isNull(formulario.inicio) && _.isNull(this.state.inicio)) {
            this.setState({ inicio: formulario.inicio, fim: formulario.fim });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { formulario, TabelaHoras } = this.props;
        if (!this.state.confirmacao && formulario.tabela !== "" &&
            !_.isNull(prevState.inicio) && !_.isNull(prevState.fim) &&
            !_.isNull(this.state.inicio) && !_.isNull(this.state.fim) &&
            (!_.isEqual(this.state.inicio, prevState.inicio) || !_.isEqual(this.state.fim, prevState.fim))) {
            this.openConfirmacao();
        }

        if (!_.isNull(TabelaHoras.jornada) && (_.isNull(formulario.jornada) || formulario.jornada === "")) {
            var obj = JSON.parse(JSON.stringify(formulario));
            obj.jornada = TabelaHoras.jornada;
            this.props.onChangeForm(obj);
        }
    }

    clearTabela = () => {
        this.props.onChange({ target: { name: "tabela", value: "" } });
        this.openConfirmacao();
    }

    openConfirmacao = () => {
        this.setState(_.set({ ...this.state }, "confirmacao", !this.state.confirmacao));
    }

    renderEditableTime = (cellInfo) => {
        const { formulario, readOnly } = this.props;
        var cellValue = "";
        if (formulario !== null && formulario.tabela !== "") {
            cellValue = formulario.tabela[cellInfo.index][cellInfo.column.id];
        }

        return (
            <TextField
                name={cellInfo.column.id}
                type={"time"}
                value={cellValue}
                onChange={this.handleInputTimeChange.bind(null, cellInfo)}
                variant="standard"
                fullWidth
                disabled={readOnly || !this.canBeEdit(formulario.tabela[cellInfo.index])}
                InputLabelProps={{
                    shrink: true,
                }}
                InputProps={{
                    disableUnderline: true
                }}
            />
        );
    };

    renderEditableText = (cellInfo) => {
        const { formulario, readOnly } = this.props;
        var cellValue = "";
        if (formulario !== null && formulario.tabela !== "") {
            cellValue = formulario.tabela[cellInfo.index][cellInfo.column.id];
        }

        return (
            <TextField
                name={cellInfo.column.id}
                value={cellValue}
                onChange={this.handleInputChange.bind(null, cellInfo)}
                variant="standard"
                fullWidth
                disabled={readOnly}
                InputLabelProps={{
                    shrink: true,
                }}
                InputProps={{
                    disableUnderline: true
                }}
            />
        );
    };

    renderEditableNatureza = (cellInfo) => {
        const { formulario, readOnly } = this.props;
        var cellValue = "";
        if (formulario !== null && formulario.tabela !== "") {
            cellValue = formulario.tabela[cellInfo.index][cellInfo.column.id];
        }

        return (
            <TextField
                name={cellInfo.column.id}
                value={cellValue}
                onChange={this.handleInputNaturezaChange.bind(null, cellInfo)}
                variant="standard"
                fullWidth
                disabled={readOnly}
                InputLabelProps={{
                    shrink: true,
                }}
                InputProps={{
                    disableUnderline: true
                }}
                select
            >
                {Helpers.GetNaturezaTabelaHoras().map(item => (
                    <MenuItem key={"ItemNatureza_" + item.id} value={item.id}>{item.label}</MenuItem>
                ))}
            </TextField>
        );
    };

    handleInputChange = (cellInfo, event, _AState) => {
        var ATabela = null;
        if (this.props.formulario.tabela === "") {
            ATabela = new Tabela(this.state);
        }
        else {
            ATabela = JSON.parse(JSON.stringify(this.props.formulario.tabela));
        }
        if (!_.isNull(ATabela)) {
            ATabela[cellInfo.index][cellInfo.column.id] = event.target.value;
            var AEvent = { target: { name: "tabela", value: ATabela } };
            this.props.onChange(AEvent);
        }
    }

    handleInputNaturezaChange = (cellInfo, event, _AState) => {
        const { formulario } = this.props;
        var ATabela = null;
        if (this.props.formulario.tabela === "") {
            ATabela = new Tabela(this.state);
        }
        else {
            ATabela = JSON.parse(JSON.stringify(this.props.formulario.tabela));
        }

        if (!_.isNull(ATabela)) {
            ATabela[cellInfo.index][cellInfo.column.id] = event.target.value;
            this.setTimeByNatureza(ATabela[cellInfo.index]);
            var AEvent = { target: { name: "tabela", value: ATabela } };
            this.props.onChange(AEvent);
        }
    }

    handleInputTimeChange = (cellInfo, event, _AState) => {
        const { formulario } = this.props;
        var ATabela = null;
        if (formulario.tabela === "") {
            ATabela = new Tabela(this.state);
        }
        else {
            ATabela = JSON.parse(JSON.stringify(formulario.tabela));
        }
        if (!_.isNull(ATabela)) {
            ATabela[cellInfo.index][cellInfo.column.id] = event.target.value;
            //this.setDiferenca(ATabela[cellInfo.index], formulario.jornada);
            var AEvent = { target: { name: "tabela", value: ATabela } };
            this.props.onChange(AEvent);
        }
    }

    setTimeByNatureza = (_ALinha) => {
        const { formulario } = this.props;
        if ([5, 7].includes(_ALinha.natureza)) {
            _ALinha.entrada1 = _ALinha.entrada1.length > 0 ? _ALinha.entrada1 : "00:00";
            _ALinha.entrada2 = _ALinha.entrada2.length > 0 ? _ALinha.entrada2 : "00:00";
            _ALinha.saida1 = _ALinha.saida1.length > 0 ? _ALinha.saida1 : "00:00";
            _ALinha.saida2 = _ALinha.saida2.length > 0 ? _ALinha.saida2 : "00:00";
        }
        else if (_ALinha.natureza === 1) {
            _ALinha.entrada1 = formulario.jornada.entrada1;
            _ALinha.entrada2 = formulario.jornada.entrada2;
            _ALinha.saida1 = formulario.jornada.saida1;
            _ALinha.saida2 = formulario.jornada.saida2;
        }
        else if ([2, 8].includes(_ALinha.natureza)) {
            _ALinha.entrada1 = "";
            _ALinha.entrada2 = "";
            _ALinha.saida1 = "";
            _ALinha.saida2 = "";
            _ALinha.diferenca = "";
            _ALinha.diferencadescricao = "";
        }
        //this.setDiferenca(_ALinha, formulario.jornada);
    }

    setDiferenca = (_ALinha, _AJornada) => {
        var AHorasJornada = 0;
        var AEntrada = "";
        var ASaida = "";

        if (_ALinha.natureza !== "") {
            AEntrada = new Date("1900-01-01 " + _AJornada.entrada1);
            ASaida = new Date("1900-01-01 " + _AJornada.saida1);
            AHorasJornada += (((ASaida - AEntrada) / 1000) / 60) / 60;

            AEntrada = new Date("1900-01-01 " + _AJornada.entrada2);
            ASaida = new Date("1900-01-01 " + _AJornada.saida2);
            AHorasJornada += (((ASaida - AEntrada) / 1000) / 60) / 60;

            if (_ALinha.entrada1.length > 0 && _ALinha.saida1.length > 0) {
                var AEntrada = new Date("1900-01-01 " + _ALinha.entrada1);
                var ASaida = new Date("1900-01-01 " + _ALinha.saida1);
                _ALinha.total1 = (((ASaida - AEntrada) / 1000) / 60) / 60;
            }

            if (_ALinha.entrada2.length > 0 && _ALinha.saida2.length > 0) {
                var AEntrada = new Date("1900-01-01 " + _ALinha.entrada2);
                var ASaida = new Date("1900-01-01 " + _ALinha.saida2);
                _ALinha.total2 = (((ASaida - AEntrada) / 1000) / 60) / 60;
            }

            if ([1, 3].includes(_ALinha.natureza)) {
                _ALinha.diferenca = (_ALinha.total1 + _ALinha.total2);
            }
            else {
                _ALinha.diferenca = (_ALinha.total1 + _ALinha.total2) - AHorasJornada;
            }

            _ALinha.diferencadescricao = Helpers.convertNumToTime(_ALinha.diferenca);
        }
    }

    canBeEdit = (_ALinha) => {
        if (!_.isUndefined(_ALinha) && !_.isNull(_ALinha) && [1, 2, 8].includes(_ALinha.natureza)) {
            return false;
        }
        else {
            return true;
        }
    }

    getRows = () => {
        var AResponse = [];
        var ATabela = new Tabela(this.state);
        if (this.props.formulario.tabela !== "") {
            ATabela = JSON.parse(JSON.stringify(this.props.formulario.tabela));
        }
        Object.keys(ATabela).forEach(key => {
            AResponse.push(ATabela[key]);
        });
        return AResponse;
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
        this.props.onChange(event);
    };

    getDataFormatted = (_AItens) => {
        const { formulario, pessoaformulario } = this.props;
        var ADados = {};
        _AItens.forEach(item => {
            item.naturezadescricao = "";
            if (item.natureza !== "") {
                item.naturezadescricao = _.find(Helpers.GetNaturezaTabelaHoras(), { id: item.natureza }).label;
            }
        });
        ADados.dataatual = Helpers.GetDataAtual();
        ADados["funcionario_nome"] = !_.isUndefined(pessoaformulario) && !_.isNull(pessoaformulario) ? pessoaformulario.nome : "";
        ADados.jornada = formulario.jornada;
        ADados.jornadadescricao = "";
        ADados.periodo = formulario.iniciodescricao + " a  " + formulario.fimdescricao;
        ADados.itens = _AItens;
        this.calcularHoras(ADados);
        return JSON.stringify(ADados);
    }

    calcularHoras = (_ADados) => {
        var HoraNormal = 0;
        var HoraExtra = 0;
        var AtestadoMedico = 0;
        var Falta = 0;
        var Acordo = 0;
        _ADados.itens.forEach(linha => {
            switch (linha.natureza) {
                case 1: HoraNormal += linha.diferenca; break;
                case 3: Acordo += linha.diferenca; break;
                case 5: Falta += linha.diferenca; break;
                case 6: HoraExtra += linha.diferenca; break;
                case 7: AtestadoMedico += linha.diferenca; break;
                default: break;
            }
        });
        _ADados.horanormaldescricao = Helpers.convertNumToTime(HoraNormal);
        _ADados.horaextradescricao = Helpers.convertNumToTime(HoraExtra);
        _ADados.atestadomedicodescricao = Helpers.convertNumToTime(AtestadoMedico);
        _ADados.faltadescricao = Helpers.convertNumToTime(Falta);
        _ADados.acordodescricao = Helpers.convertNumToTime(Acordo);
    }

    render() {
        const { classes } = this.props;
        const Columns = [
            {
                Header: "",
                fixed: "left",
                columns: [
                    {
                        Header: "Dia",
                        accessor: "diasemana",
                        className: "justify-center",
                        width: 80
                    }
                ]
            },
            {
                Header: "",
                columns: [
                    {
                        Header: "Entrada",
                        accessor: "entrada1",
                        width: 200,
                        className: "justify-center",
                        Cell: this.renderEditableTime
                    },
                    {
                        Header: "Saída",
                        accessor: "saida1",
                        width: 200,
                        className: "justify-center",
                        Cell: this.renderEditableTime
                    },
                    {
                        Header: "Entrada",
                        accessor: "entrada2",
                        width: 200,
                        className: "justify-center",
                        Cell: this.renderEditableTime
                    },
                    {
                        Header: "Saída",
                        accessor: "saida2",
                        width: 200,
                        className: "justify-center",
                        Cell: this.renderEditableTime
                    },
                    {
                        Header: "Natureza",
                        accessor: "natureza",
                        width: 200,
                        className: "justify-center",
                        Cell: this.renderEditableNatureza
                    },
                    {
                        Header: "Observações",
                        accessor: "observacao",
                        //width: 400,
                        className: "justify-center",
                        Cell: this.renderEditableText
                    }
                ]
            }
        ];
        const form = this.state;
        const AData = this.getRows();
        return (
            <React.Fragment>
                <div className="flex w-full">
                    <TextField
                        className="w-1/2 mr-8"
                        label={"Início"}
                        id="inicio"
                        name="inicio"
                        value={form.inicio}
                        onChange={this.handleChange}
                        variant="outlined"
                        fullWidth
                        required
                        type="Date"
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField
                        className="w-1/2"
                        label={"Fim"}
                        id="fim"
                        name="fim"
                        value={form.fim}
                        onChange={this.handleChange}
                        variant="outlined"
                        fullWidth
                        required
                        type="Date"
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </div>
                {this.props.formulario.tabela !== "" &&
                    <div className="flex w-full">
                        <div className="flex-1" />
                        <ImprimirApp
                            data={this.getDataFormatted(AData)}
                            type="Icon"
                            key="btnImprimir"
                            id="ApontamentoHoras"
                            idrelatorio={114}
                            className="mr-12 bg-blue hover:bg-blue"
                        />
                    </div>
                }
                {((!_.isNull(form.inicio) && !_.isNull(form.fim)) || this.props.formulario.tabela !== "") &&
                    <FuseAnimate animation="transition.slideUpIn" delay={300}>
                        <ReactTableFixedColumns
                            className={classNames(classes.root, "-striped -highlight border-0")}
                            data={AData}
                            columns={Columns}
                            defaultPageSize={31}
                            showPagination={false}
                        />
                    </FuseAnimate>
                }
                <XAPPDialog
                    id="TabelaHoras"
                    onClose={() => { }}
                    open={form.confirmacao}
                    fullWidth
                    maxWidth="xs"
                >
                    <AppBar position="static" elevation={1}>
                        <Toolbar className="flex w-full min-h-0">
                            <MdWarning className="mr-8 text-32 text-orange-light" />
                            <Typography variant="subtitle1 text-white">
                                {"Confirmação"}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <DialogContent>
                        <div className="flex pt-8">
                            <Typography
                                className="h3"
                                color="textPrimary"
                            >
                                {"Ao alterar o período os dados preenchidos anteriormente serão apagadados. Tem certeza que deseja alterar?"}
                            </Typography>
                        </div>
                    </DialogContent>
                    <AppBar position="static" elevation={3} color="textSecondary">
                        <Toolbar className="flex w-full justify-end min-h-0">
                            <DialogActions>
                                <React.Fragment>
                                    <XAPPButton
                                        type="Button"
                                        className="bg-green hover:bg-green text-white mr-8"
                                        onClick={(ev) => {
                                            ev.stopPropagation();
                                            this.clearTabela();
                                        }}
                                        variant="contained"
                                        iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                        icon={null}
                                        label={"Sim"}
                                        key={"Confirma_Sim"}
                                    />
                                    <XAPPButton
                                        type="Button"
                                        className="bg-red hover:bg-red text-white"
                                        onClick={(ev) => {
                                            ev.stopPropagation();
                                            this.openConfirmacao();
                                        }}
                                        variant="contained"
                                        iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                        icon={null}
                                        label={"Não"}
                                        key={"Confirma_Nao"}
                                    />
                                </React.Fragment>
                            </DialogActions>
                        </Toolbar>
                    </AppBar>
                </XAPPDialog>
            </React.Fragment>
        )
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getJornada: Actions.getJornada,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ TabelaHoras, auth }) {
    return {
        TabelaHoras: TabelaHoras,
        user: auth.user.data
    }
}

export default withReducer('TabelaHoras', reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(TabelaHoras))));
